import React from 'react';
import styled from 'styled-components';

export const StepContainer = ({ children, ...otherProps }) => {
  const childrenWithProps = React.Children.map(children, child => {
    return React.cloneElement(child, otherProps);
  });

  return <StyledStepContainer {...otherProps}>{childrenWithProps}</StyledStepContainer>;
};

export const StepWizardActionContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.insetLarge};
  padding-top: ${({ theme }) => theme.spacing.insetLarge};
  padding: 0 ${({ theme }) => theme.spacing.insetLarge};
`;

export const StepWizardField = styled.div`
  padding: 0 ${({ theme }) => theme.spacing.insetLarge};
  margin-bottom: ${({ theme }) => theme.spacing.insetLarge};
`;

export const StepWizardFieldWithBorder = styled.div`
  padding: ${({ theme }) => theme.spacing.insetLarge};
  padding-top: 0;
  padding-bottom: ${({ theme }) => theme.spacing.insetMedium};
  margin-bottom: ${({ theme }) => theme.spacing.insetLarge};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray300};
`;

export const StyledStepContainer = styled.div``;

export const StepDescription = styled.p`
  line-height: 162%;
  margin-bottom: ${({ theme }) => theme.spacing.insetLarge};
  text-align: left;
`;
